import BaseInputText     from "./components/BaseInputText";
import BaseInputTextarea from "./components/BaseInputTextarea";
import BaseInputCombobox   from "./components/BaseInputCombobox";
import BaseInputSelect   from "./components/BaseInputSelect";
import BaseInputSwitch   from "./components/BaseInputSwitch";
import BaseInputDate     from "./components/BaseInputDate";
import BaseInputTime     from "./components/BaseInputTime";
import TimeZoneInput     from "./components/TimeZoneInput";
import DateTimeInput     from "./components/DateTimeInput";
import CurrencyInput     from "./components/CurrencyInput";

export default {
    install(Vue, options) {
        Vue.component("BaseInputText", BaseInputText);
        Vue.component("BaseInputTextarea", BaseInputTextarea);
        Vue.component("BaseInputCombobox", BaseInputCombobox);
        Vue.component("BaseInputSelect", BaseInputSelect);
        Vue.component("BaseInputSwitch", BaseInputSwitch);
        Vue.component("BaseInputDate", BaseInputDate);
        Vue.component("BaseInputTime", BaseInputTime);
        Vue.component("TimeZoneInput", TimeZoneInput);
        Vue.component("DateTimeInput", DateTimeInput);
        Vue.component("CurrencyInput", CurrencyInput);
    }
}